import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GetFormatedDateWithTime } from '../../../../common/Utils';
import Layout from './Layout';
import axios from "axios";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';


const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const Form = (props) => {
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const getCarrierUrl = "wm/TransactionManagement/GetCarrier"
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;


    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            props.setSearchPanelStatus((prevStatus) => !prevStatus);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = async (e) => {
        e.event.stopPropagation();
        props.searchData(props.formFields);
    };
    const deleteRecords = async (e) => {
        e.event.stopPropagation();
        props.deleteRecords();
    };
    const ReSubmitRFHeader = async (e) => {
        e.event.stopPropagation();
        props.ReSubmitRFHeader();
    };
    const handleFieldChange = useCallback((name, value) => {

    }, []);
    const handleReset = (e) => {
        e.event.stopPropagation();
        props.handleReset();
    };
    const formRefs = useRef({});
    const GetLookupData = async (name, url, accessToken, formRefs, setForceRender, forceRender) => {
        try {
            const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}`, {
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const responseData = response.data;
            if (responseData.success) {
                const newOptions = responseData.lookups.map(item => ({
                    id: item.rowid,
                    name: item.code
                }));
                if (formRefs.current[name]) {
                    formRefs.current[name].instance().option('dataSource', newOptions);
                    formRefs.current[name].instance().option('valueExpr', 'id');
                    formRefs.current[name].instance().option('displayExpr', 'name');
                    setForceRender(!forceRender);
                }
                return newOptions;
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;

        }
    };
    const loadLookupClient = (name, data) => {

        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (formRefs.current[name]) {

                formRefs.current[name].instance().option('dataSource', newOptions);
                formRefs.current[name].instance().option('valueExpr', 'id');
                formRefs.current[name].instance().option('displayExpr', 'name');
            }

        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const handleSalesOrderSearchFormLoad = useCallback(() => {
            const statusOptions = [
                { "Rowid": 'F', "Code": "Failed Message" },
                { "Rowid": 'Z', "Code": "Closed and Processed" },
                { "Rowid": 'O', "Code": "Open and Unprocessed" },
            ];
        loadLookupClient("STATUS", statusOptions);
    }, []);

    return (
        <form onSubmit={(e) => handleFormSubmit(e)}>
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                    {props.pageTitle}
                                </h6>
                            </div>
                        </Item>

                       
                        <Item location="after">
                            <Button className="accordianButton"    onClick={(e) => handleFormSubmit(e)} text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={(e) => handleReset(e)} text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='892D2ACE-1C21-454A-BD6B-A10E14C671D3'
                            layoutName='MyTestForm'
                            defaultFormSchema={Layout}
                            formFields={props.formFields}
                            setformFields={props.setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
        </form>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);